module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('MarkupPopup', {
    on: {
      "close": _vm.hidePopup
    }
  }, [_c('NavHash', {
    attrs: {
      "slot": "nav",
      "items": _vm.popupNav
    },
    slot: "nav"
  }), (_vm.isSignupVisible) ? _c('FormSignup', {
    key: "signup",
    attrs: {
      "validateBeforeSubmit": true
    },
    on: {
      "submit": _vm.hidePopup
    }
  }) : _vm._e(), (_vm.isSigninVisible) ? _c('FormSignin', {
    key: "signin",
    on: {
      "submit": _vm.hidePopup
    }
  }) : _vm._e(), (_vm.isForgetVisible) ? _c('FormForget', {
    key: "forget"
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c9306ac","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/default/popup/forms/component.vue
// module id = 8b6577dec098d9c4c9cd
// module chunks = 0